/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cv_Check_Start_ReviewInputs */

const en_cv_check_start_review = /** @type {(inputs: Cv_Check_Start_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Review resume`)
};

const de_cv_check_start_review = /** @type {(inputs: Cv_Check_Start_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lebenslauf prüfen`)
};

/**
* | output |
* | --- |
* | "Review resume" |
*
* @param {Cv_Check_Start_ReviewInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const cv_check_start_review = /** @type {((inputs?: Cv_Check_Start_ReviewInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Check_Start_ReviewInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cv_check_start_review(inputs)
	return en_cv_check_start_review(inputs)
});